import { Field } from "components/dynamic/DynamicForm";
import { Option } from "components/select/Select";
import { TFunction } from "i18next";
import { Company } from "types/companyTypes";
import { ScopeType } from "types/globalTypes";

export const basicInfoSchema = (
  t: TFunction<"translation", undefined>,
  scope: ScopeType,
  organizationOptions: Option[],
  industrialOptions: Option[],
  isNationalIdLocked: boolean,
  provincesItems: Option[],
  searchUsers: (text: string) => Promise<Option[]>,
  isViewMode: boolean,
  data?: Company
): Field[] => {
  const userLabel = data?.user?.fullname || data?.user?.fullName || "-";
  const userId = data?.user?.id ?? data?.userId;
  return [
    {
      name: "name",
      label: t("company.fields.name"),
      type: "text",
      disabled: isViewMode,
      required: true,
    },
    ...(scope === "admin"
      ? [
          {
            name: "userId",
            label: t("company.fields.user"),
            type: "select",
            disabled: isViewMode,
            onSearch: searchUsers,
            required: true,
            ...(userId
              ? {
                  defaultValue: {
                    default: {
                      label: userLabel,
                      value: userId,
                    },
                  },
                }
              : {}),
          },
        ]
      : []),
    {
      name: "nationalId",
      label: t("company.fields.nationalId"),
      type: "text",
      required: true,
      disabled: isViewMode || isNationalIdLocked,
    },
    {
      name: "provinceId",
      label: t("company.fields.province"),
      type: "select",
      options: provincesItems,
      disabled: isViewMode,
      required: true,
    },
    {
      name: "organizationId",
      label: t("organization.fieldName"),
      type: "select",
      disabled: isViewMode,
      options: organizationOptions,
    },
    {
      name: "industrialId",
      label: t("company.fields.industrialId"),
      type: "select",
      options: industrialOptions,
      disabled: isViewMode,
    },
    {
      name: "industrialOther",
      label: t("company.fields.industrialOther"),
      type: "text",
      disabled: isViewMode,
    },
    {
      name: "meta.brandName",
      label: t("company.fields.brandName"),
      type: "text",
      disabled: isViewMode,
    },
    {
      name: "meta.website",
      label: t("company.fields.website"),
      type: "text",
      disabled: isViewMode,
    },
    {
      name: "meta.companyAddress",
      label: t("company.fields.companyAddress"),
      type: "textarea",
      disabled: isViewMode,
      required: true,
    },
    {
      name: "meta.companyPhone",
      label: t("company.fields.companyPhone"),
      type: "phone",
      disabled: isViewMode,
      required: true,
    },
    {
      name: "meta.officeAddress",
      label: t("company.fields.officeAddress"),
      type: "textarea",
      disabled: isViewMode,
    },
    {
      name: "meta.officePhone",
      label: t("company.fields.officePhone"),
      type: "phone",
      disabled: isViewMode,
    },
    {
      name: "meta.email",
      label: t("company.fields.email"),
      type: "email",
      disabled: isViewMode,
      required: true,
    },
    {
      name: "meta.agentName",
      label: t("company.fields.agentName"),
      type: "text",
      disabled: isViewMode,
      required: true,
    },
    {
      name: "meta.agentMobile",
      label: t("company.fields.agentMobile"),
      type: "mobile",
      disabled: isViewMode,
      required: true,
    },
  ];
};
